"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureFlagConfig = getFeatureFlagConfig;
const featureFlagsHolderObject_1 = require("./featureFlagsHolderObject");
function getFeatureFlagConfig() {
    if (featureFlagsHolderObject_1.featureFlagsHolderObject.config) {
        return featureFlagsHolderObject_1.featureFlagsHolderObject.config;
    }
    else {
        if (typeof platform === 'object' && platform.getFeatureFlags && typeof platform.getFeatureFlags === 'function') {
            return platform.getFeatureFlags();
        }
        else if (typeof window === 'object' && window.juvareFeatureFlags) {
            return window.juvareFeatureFlags;
        }
        else {
            return undefined;
        }
    }
}
